import { DfAutoComplete } from "./DfAutoComplete";
import {
  AfterViewInit,
  Component,
  ChangeDetectorRef,
  Renderer2,
  ElementRef,
  IterableDiffers,
  Injector,
} from "@angular/core";
import { DomHandler } from "@bfx/primeng/dom";
import { ObjectUtils } from "@bfx/primeng/utils";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import {
  AUTOCOMPLETE_VALUE_ACCESSOR,
  AUTOCOMPLETE_VIEW_PROVIDERS,
  BfxAutoCompleteComponentState,
} from "../../bfx-element-library/bfx-autocomplete.component";
import { GridApi } from "ag-grid-community";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OELoggerService } from "app/order-entry/services/basic/oe-logger.service";
import { BfxFieldSelectDirective } from "../../../shared/base-components/bfx-field-select";
import { BfxInputDirective } from "../../../shared/base-components/bfx-input";

@Component({
  selector: "vehicle-ccy-auto",
  templateUrl: "./html/DfAutoComplete.html",
  host: {
    "[class.ui-inputwrapper-filled]": "filled",
    "[class.ui-inputwrapper-focus]": "focus",
  },
  providers: [DomHandler, ObjectUtils, AUTOCOMPLETE_VALUE_ACCESSOR],
  viewProviders: AUTOCOMPLETE_VIEW_PROVIDERS,
  standalone: false,
})
export class VehicleCcyAuto extends DfAutoComplete {
  private api: GridApi;

  constructor(
    private ccyPairService: CcyPairPromiseLookupService,
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldSelectDirective,
    el: ElementRef,
    domHandler: DomHandler,
    renderer: Renderer2,
    objectUtils: ObjectUtils,
    cd: ChangeDetectorRef,
    differs: IterableDiffers,
    oeLogger: OELoggerService,
  ) {
    super(
      injector,
      inputDirective,
      fieldDirective,
      el,
      domHandler,
      renderer,
      objectUtils,
      cd,
      differs,
      oeLogger,
      null,
    );
    this.oeLogger = this.oeLogger.for(__dirname);
  }

  agInit(params: any): void {
    super.agInit(params);
    if (this.isCancelBeforeStart()) return;
    this.api = params.api;
    this.loading = true;
    let pairArr: Array<string> = this.currentData.instrument.split("/");
    let base: string = pairArr[0];
    let nonBase: string = pairArr[1];

    this.autoHighlightFirstIfNoValue = false;

    this.ccyPairService.getVehicleCurrencies(base, nonBase).then((values) => {
      this.fullProvider = values;
      if (this.fullProvider) {
        let selItem: any = null;
        let hilightIdx: number = 0;
        for (let item of this.fullProvider) {
          if (item.label == params.value) {
            selItem = item;
            break;
          }
          hilightIdx++;
        }
        if (null != selItem) {
          this.autoHighlightIndex = hilightIdx;
        }
        this.suggestions = this.fullProvider.concat();
        this.writeValue(selItem);
      }
    });
  }

  isCancelBeforeStart?(): boolean {
    return this.isComponentLeg || !this.isRowSelected;
  }

  isCancelAfterEnd?(): boolean {
    return this.isComponentLeg || !this.isRowSelected;
  }

  selectItem(option: any, focus = this.focusInputOnSelect) {
    super.selectItem(option, focus);

    if (this.currentData) {
      if (option) {
        this.currentData["crosses"] = option.crosses;
      } else {
        delete this.currentData["crosses"];
      }
    }
    setTimeout(() => {
      // prevent premature read of value
      if (this.api != null) {
        try {
          let editingCells = this.api.getEditingCells();

          if (Array.isArray(editingCells) && editingCells.length > 0) {
            this.api.stopEditing(false);
          }
        } catch (e) {
          logger.out.error(
            `${this.constructor.name}.selectItem event:%O error stopping edit:%O`,
            event,
            e,
          );
        }
      }
    }, 4);
  }

  protected stateChange(newState: BfxAutoCompleteComponentState): void {
    if (newState == BfxAutoCompleteComponentState.INVALID) {
      newState = BfxAutoCompleteComponentState.ACTIVE;
    }
    super.stateChange(newState);
  }
}
